import { apiRequest } from './api';

/* ── Types ── */

export interface OrganizationCreator {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
}

export interface OrganizationRecord {
    id: string;
    name: string;
    slug: string;
    email: string | null;
    phone: string | null;
    logo_url: string | null;
    website: string | null;
    address_line1: string | null;
    address_line2: string | null;
    city: string | null;
    state: string | null;
    postal_code: string | null;
    country: string | null;
    status: string;
    created_by: string;
    created_at: string;
    updated_at: string;
    creator: OrganizationCreator | null;
}

/* ── API calls ── */

export async function fetchOrganizations(): Promise<OrganizationRecord[]> {
    const res = await apiRequest<OrganizationRecord[]>('/api/organizations');
    return res.data;
}

export interface CreateOrganizationPayload {
    name: string;
    slug: string;
    email?: string | null;
    phone?: string | null;
    address_line1?: string | null;
    address_line2?: string | null;
    city?: string | null;
    state?: string | null;
    postal_code?: string | null;
    country?: string | null;
    website?: string | null;
    logo_url?: string | null;
}

export async function createOrganization(payload: CreateOrganizationPayload): Promise<OrganizationRecord> {
    const res = await apiRequest<OrganizationRecord>('/api/organizations', {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    return res.data;
}
